module.exports = __webpack_public_path__ + "static/media/PDF_128.b1375c2f.pdf";